import styled from "styled-components";

const FooterStylesContainer = styled.footer`
    background-color: #efefef;
    padding-top: 30px;
    padding-bottom: 30px;

    .social {
        .link-main {
            background: rgba(220,220,220,0.8);
            padding: 2px 5px;
            border-radius: 4px;
            &:hover {
                background: #ddd;
            }
        }
    }
`;  
export { FooterStylesContainer };
